import { Routes, Route } from "react-router-dom";
import MainLayout from "@/layouts/MainLayout";
import CatalogView from "@/components/views/CatalogView";

// Pages
import Dashboards from "@/pages/Dashboards";
import Tasks from "@/pages/Tasks";
import TaskDetail from "@/pages/Tasks/_id";
import TaskTemplates from "@/pages/TaskTemplates";
import TaskTemplateDetail from "@/pages/TaskTemplates/_id";
import Calendar from "@/pages/Calendar";
import Requests from "@/pages/Requests";
import MyRequests from "@/pages/MyRequests";
import CompanyStructure from "@/pages/CompanyStructure";
import Objects from "@/pages/Objects";
import ObjectsDetail from "@/pages/Objects/_id";
import Profile from "@/pages/Profile";
import Notices from "@/pages/Notices";
import NotFound from "@/pages/NotFound";
import FolderView from "@/pages/Folder";
import UnitMembers from "@/pages/UnitMembers";
import Report from "@/pages/Report/_id";
import MapView from "@/pages/MapView";
import Sprints from "@/pages/Sprints";
import SprintDetail from "@/pages/Sprints/_id";
import Search from "@/pages/Search";
import RequestForm from "@/pages/RequestForm/_id";
import RequestEntry from "@/pages/RequestEntry/_id";

const MainRoutes = ({ config, redDot }) => (
  <MainLayout config={config} redDot={redDot}>
    <Routes>
      {/* Главная страница */}
      <Route path="/" element={<Dashboards />} />

      {/* Рабочие группы и их разделы */}
      <Route path="/units">
        <Route path=":unit_uuid/u-tasks">
          <Route path="u-tasks-list">
            <Route index element={<Tasks />} />
            <Route path=":id" element={<TaskDetail />} />
          </Route>
          <Route path="u-tasks-templates">
            <Route index element={<TaskTemplates />} />
            <Route path=":id" element={<TaskTemplateDetail />} />
          </Route>
        </Route>
        <Route path=":unit_uuid/u-calendar" element={<Calendar />} />
        <Route path=":unit_uuid/u-files" element={<CatalogView />}>
          <Route path=":id" element={<FolderView />} />
        </Route>
        <Route path=":unit_uuid/u-objects">
          <Route path=":definitionId" element={<Objects />} />
          <Route path=":definitionId/:objectId" element={<ObjectsDetail />} />
        </Route>
        <Route path=":unit_uuid/u-members" element={<UnitMembers />} />
        <Route path=":unit_uuid/u-sprints">
          <Route index element={<Sprints />} />
          <Route path=":id" element={<SprintDetail />} />
        </Route>
      </Route>

      {/* Задачи */}
      <Route path="/tasks">
        <Route path="t-list">
          <Route index element={<Tasks />} />
          <Route path=":id" element={<TaskDetail />} />
        </Route>
        <Route path="t-templates">
          <Route index element={<TaskTemplates />} />
          <Route path=":id" element={<TaskTemplateDetail />} />
        </Route>
      </Route>

      {/* Календарь */}
      <Route path="/calendar" element={<Calendar />} />

      {/* Спринты */}
      <Route path="/sprints">
        <Route index element={<Sprints />} />
        <Route path=":id" element={<SprintDetail />} />
      </Route>

      {/* Заявки */}
      <Route path="/request-registration/:uuid" element={<Requests />} />
      <Route path="/my-requests" element={<MyRequests />} />
      <Route path="/my-requests/:uuid" element={<RequestEntry />} />
      <Route path="/in-request-form/:uuid/:id" element={<RequestForm />} />

      {/* Структура компании */}
      <Route path="/company-structure" element={<CompanyStructure />} />

      {/* Файлы */}
      <Route path="/files" element={<CatalogView />}>
        <Route path=":id" element={<FolderView />} />
      </Route>

      {/* Мои объекты */}
      <Route path="/my-objects">
        <Route path=":definitionId" element={<Objects />} />
        <Route path=":definitionId/:objectId" element={<ObjectsDetail />} />
      </Route>

      {/* Карта с объектами */}
      <Route path="/map-view" element={<MapView />} />

      {/* Отчеты */}
      <Route path="/custom-reports/:id" element={<Report />} />

      {/* Профиль */}
      <Route path="/profile" element={<Profile />} />

      {/* Уведомления */}
      <Route path="/notices">
        <Route path=":tab" element={<Notices />} />
      </Route>

      {/* Поиск */}
      <Route path="/search" element={<Search />} />

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </MainLayout>
);

export default MainRoutes;
